import cn from "classnames";

const variants = {
  primary: "bg-bh-600 hover:bg-bh-700 text-white",
  secondary: "bg-gray-100 hover:bg-gray-200 text-gray-800",
  danger: "bg-red-600 hover:bg-red-700 text-white",
  ghost: "bg-transparent hover:bg-gray-100 text-gray-700",
  outline: "border border-gray-300 hover:bg-gray-50 text-gray-700",
};
const sizes = {
  sm: "px-3 py-1.5 text-sm",
  md: "px-4 py-2 text-sm",
  lg: "px-5 py-2.5 text-base",
};

export default function Button({
  children, variant = "primary", size = "md",
  className, disabled, loading, icon: Icon, shortcut, ...props
}) {
  return (
    <button
      {...props}
      disabled={disabled || loading}
      className={cn(
        "inline-flex items-center gap-2 rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-bh-500 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed",
        variants[variant], sizes[size], className
      )}
    >
      {loading && (
        <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
        </svg>
      )}
      {Icon && !loading && <Icon className="h-4 w-4" />}
      {children}
      {shortcut && (
        <kbd className="ml-0.5 text-[10px] font-sans font-normal opacity-55 leading-none">
          {shortcut}
        </kbd>
      )}
    </button>
  );
}
